export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.searchTable.selectToDelete': 'Please select items to delete',

  'pages.403.subTitle': 'Sorry, you do not have permission to access this page.',
  'pages.403.buttonText': 'Back to home',

  // Task related fields
  'pages.task.owner': 'Owner',
  'pages.task.propertyCert': 'Certificate of Title No.',
  'pages.task.region': 'Province/City/District',
  'pages.task.cardAddress': 'Registered Address',
  'pages.task.houseUsage': 'Registered House Usage',
  'pages.task.landUsage': 'Registered Land Usage',
  'pages.task.houseRightNature': 'Registered House Right Nature',
  'pages.task.landRightNature': 'Registered Land Right Nature',
  'pages.task.houseRightType': 'Registered House Right Type',
  'pages.task.landRightType': 'Registered Land Right Type',
  'pages.task.landExpiry': 'Land Use Right Expiry Date',
  'pages.task.building': 'Building Complex',
  'pages.task.buildingNo': 'Building No.',
  'pages.task.unitNo': 'Unit No.',
  'pages.task.householdNo': 'Household No.',
  'pages.task.bedroom': 'Bedroom',
  'pages.task.hall': 'Hall',
  'pages.task.kitchen': 'Kitchen',
  'pages.task.toilet': 'Toilet',
  'pages.task.buildingArea': 'Building Area (㎡)',
  'pages.task.sharedLandArea': 'Shared Land Area (㎡)',
  'pages.task.sharedBuildingArea': 'Shared Building Area (㎡)',
  'pages.task.landArea': 'Land Use Right Area (㎡)',
  'pages.task.innerArea': 'Inner Area (㎡)',
  'pages.task.actualUsedType': 'Actual Usage',
  'pages.task.usageStatus': 'Usage Status',
  'pages.task.floorPosition': 'Floor Position',
  'pages.task.totalFloors': 'Total Floors',
  'pages.task.finishTime': 'Completion Year',
  'pages.task.purchaseDuration': 'Purchase Duration',
  'pages.task.taxPolicy': 'Tax Policy',
  'pages.task.shopsType': 'Shop Type',
  'pages.task.shopsAmount': 'Shop Rent (¥/month)',
  'pages.task.coOwnership': 'Co-owner',
  'pages.task.coOwnershipCircumstance': 'Co-ownership Circumstance',
  'pages.task.ownershipInfo': 'Ownership Information',
  'pages.task.smartRecognition': 'Smart Recognition',
  'pages.task.smartCalculation': 'Smart Calculation',
  'pages.task.comparativeData': 'Comparative Data',
  'pages.task.calculationTable': 'Calculation Table',
  'pages.task.downloadReportPDF': 'Download Report PDF',
  'pages.task.viewReport': 'View Report',
  'pages.task.review.totalAmountPrecision': 'Total amount precision',
  'pages.task.review.precisionOnes': 'Ones',
  'pages.task.review.precisionTens': 'Tens',
  'pages.task.review.precisionHundreds': 'Hundreds',
  'pages.task.review.precisionThousands': 'Thousands',
  'pages.task.review.precisionTenThousands': 'Ten thousands',
  'pages.task.review.precisionHundredThousands': 'Hundred thousands',
  'pages.task.review.precisionMillions': 'Millions',
  'pages.task.review.savePrecisionFail': 'Failed to save total amount precision',
  'pages.netValueSolution.customParams.button': 'Custom parameters',
  'pages.netValueSolution.customParams.title': 'Custom parameters',
  'pages.netValueSolution.customParams.back': 'Back',
  'pages.netValueSolution.customParams.col.name': 'Display name',
  'pages.netValueSolution.customParams.col.paramKey': 'Business key',
  'pages.netValueSolution.customParams.col.paramValue': 'Value',
  'pages.netValueSolution.customParams.col.order': 'Order',
  'pages.netValueSolution.customParams.col.action': 'Actions',
  'pages.netValueSolution.customParams.col.deductionItem': 'Deduction item',
  'pages.netValueSolution.customParams.col.calcCondition': 'Calculation condition',
  'pages.netValueSolution.customParams.col.calcFormula': 'Calculation formula',
  'pages.netValueSolution.customParams.action.edit': 'Edit',
  'pages.netValueSolution.customParams.action.delete': 'Delete',
  'pages.netValueSolution.planDetailLoading': 'Loading plan details…',
  'pages.netValueSolution.customParams.missingPlanId': 'Missing plan information. Returning to the list.',
  'pages.netValueSolution.customParams.needSavedPlan': 'Save the plan first before configuring custom parameters.',
  'pages.netValueSolution.customParams.addButton': 'Add custom parameter',
  'pages.netValueSolution.customParams.modalAddTitle': 'Add custom parameter',
  'pages.netValueSolution.customParams.modalEditTitle': 'Edit custom parameter',
  'pages.netValueSolution.customParams.confirmDelete': 'Delete this custom parameter?',
  'pages.netValueSolution.customParams.loadListFailed': 'Failed to load custom parameters',
  'pages.netValueSolution.customParams.saveSuccess': 'Saved',
  'pages.netValueSolution.customParams.saveFailed': 'Save failed',
  'pages.netValueSolution.customParams.saving': 'Saving…',
  'pages.netValueSolution.customParams.loadingDetail': 'Loading details…',
  'pages.netValueSolution.customParams.loadDetailFailed': 'Failed to load custom parameter details',
  'pages.netValueSolution.customParams.deleteSuccess': 'Deleted',
  'pages.netValueSolution.customParams.deleteFailed': 'Delete failed',
  'pages.netValueSolution.customParams.rules.name': 'Enter display name',
  'pages.netValueSolution.customParams.rules.paramKey': 'Enter business key',
  'pages.netValueSolution.customParams.rules.orderIndex': 'Enter sort order',
  'pages.netValueSolution.deduction.modalAdd': 'Add deduction item',
  'pages.netValueSolution.deduction.modalEdit': 'Edit deduction item',
  'pages.netValueSolution.deduction.modalAddTaxRate': 'Add tax rate',
  'pages.netValueSolution.table.confirmDelete': 'Delete this record?',
  'pages.netValueSolution.table.confirmDeleteWithChildren':
    'Delete this record? All related child records will also be removed.',
  'pages.netValueSolution.formulaConfig.title': 'Configure calculation formula',
  'pages.netValueSolution.add.pageTitle': 'Add net worth plan',
  'pages.netValueSolution.edit.pageTitle': 'Edit net worth plan',
  'pages.netValueSolution.taxCard.title': 'Tax deduction items',
  'pages.netValueSolution.conditionRequired': 'Select at least one calculation condition',
  'pages.netValueSolution.taxModal.deductionNameRequired': 'Enter deduction item name',
  'pages.netValueSolution.taxModal.childConditionRequired':
    'For a sub-item, select or fill at least one calculation condition before saving',
  'pages.netValueSolution.taxModal.formulaRequired':
    'Configure a calculation formula before saving',
  'pages.netValueSolution.message.savePlanSuccess': 'Net worth plan saved',
  'pages.netValueSolution.message.addDeductionSuccess': 'Deduction item added',
  'pages.netValueSolution.message.loadDetailFailed': 'Failed to load net worth plan details',
  'pages.netValueSolution.message.defaultItemCannotDelete': 'Default adjustment items cannot be deleted',
  'pages.netValueSolution.message.taxRateMax100': 'Tax rate cannot exceed 100',
  'pages.netValueSolution.message.dataAbnormalRetry': 'Data error. Close and try again.',
  'pages.netValueSolution.message.updateTaxRateSuccess': 'Tax rate updated',
  'pages.netValueSolution.message.addTaxRateSuccess': 'Tax rate added',
  'pages.netValueSolution.message.checkRequiredFieldsEmpty': 'Please fill in all required fields',
  'pages.netValueSolution.message.checkRequiredFieldsWithDetails': 'Please fix the following required fields: {details}',
  'pages.netValueSolution.message.selectAtLeastOneDeduction': 'Select at least one deduction item to submit',
  'pages.netValueSolution.message.unknownField': 'Unknown field',
  'pages.netValueSolution.addForm.label.cityName': 'Applicable city',
  'pages.netValueSolution.addForm.label.districtCode': 'Applicable district',
  'pages.netValueSolution.addForm.label.provinceCode': 'Applicable province',
  'pages.netValueSolution.addForm.label.bankId': 'Applicable bank',
  'pages.netValueSolution.addForm.label.businessLines': 'Business line',
  'pages.netValueSolution.addForm.label.businessType': 'Business type',
  'pages.netValueSolution.addForm.label.netWorthName': 'Mortgage net worth',
  'pages.netValueSolution.addForm.label.organizationId': 'Applicable organization',
  'pages.netValueSolution.addForm.rules.selectCity': 'Select applicable city',
  'pages.netValueSolution.addForm.rules.selectProvince': 'Select applicable province',
  'pages.netValueSolution.addForm.rules.selectBank': 'Select applicable bank',
  'pages.netValueSolution.addForm.rules.selectBusinessLines': 'Select business line',
  'pages.netValueSolution.addForm.rules.selectBusinessType': 'Select business type',
  'pages.netValueSolution.addForm.rules.selectNetWorth': 'Select mortgage net worth',
  'pages.netValueSolution.addForm.rules.selectOrganization': 'Select applicable organization',
  'pages.netValueSolution.addForm.placeholder.selectProvince': 'Select province',
  'pages.netValueSolution.addForm.placeholder.selectCity': 'Select city',
  'pages.netValueSolution.addForm.placeholder.selectDistrict': 'Select district',
  'pages.netValueSolution.addForm.placeholder.selectBank': 'Select applicable bank',
  'pages.netValueSolution.addForm.placeholder.selectBusinessLines': 'Select business line',
  'pages.netValueSolution.addForm.placeholder.selectBusinessType': 'Select business type',
  'pages.netValueSolution.addForm.placeholder.selectNetWorth': 'Select mortgage net worth',
  'pages.netValueSolution.addForm.placeholder.selectOrganization': 'Select applicable organization',
  'pages.netValueSolution.addForm.alertLine1':
    'The default method is the system calculation. When the user’s settings do not apply, the system uses the default method for tax values.',
  'pages.netValueSolution.addForm.alertLine2':
    'You can add custom deduction items under tax deductions; calculation uses the default method.',
  'pages.netValueSolution.addForm.alertLine3':
    'Adding tax items adds multiple tax rate scenarios for the corresponding tax type.',
  'pages.netValueSolution.addNewDeduction': 'Add deduction item',

  'pages.netValueSolution.list.title': 'Net worth plans',
  'pages.netValueSolution.list.addButton': 'Add plan',
  'pages.netValueSolution.list.loadListFailed': 'Failed to load net worth plans',
  'pages.netValueSolution.list.loadListFailedRetry': 'Failed to load plans. Please try again.',
  'pages.netValueSolution.list.missingPlanId': 'Could not get plan ID',
  'pages.netValueSolution.list.confirmDeleteTitle': 'Confirm delete',
  'pages.netValueSolution.list.confirmDeleteContent':
    'This cannot be undone. Delete this net worth plan?',
  'pages.netValueSolution.list.deleteItemLabel': 'Plan “{name}”',
  'pages.netValueSolution.list.edit': 'Edit',
  'pages.netValueSolution.list.copy': 'Copy',
  'pages.netValueSolution.list.col.province': 'Province',
  'pages.netValueSolution.list.col.city': 'City',
  'pages.netValueSolution.list.col.district': 'District',
  'pages.netValueSolution.list.col.bank': 'Bank',
  'pages.netValueSolution.list.col.businessLines': 'Business line',
  'pages.netValueSolution.list.col.businessType': 'Business type',
  'pages.netValueSolution.list.col.organization': 'Organization',
  'pages.netValueSolution.list.col.netWorthName': 'Net worth name',
  'pages.netValueSolution.list.col.deductItems': 'Tax deductions',
  'pages.netValueSolution.list.col.action': 'Actions',
  'pages.netValueSolution.list.ph.province': 'Select province',
  'pages.netValueSolution.list.ph.city': 'Select city',
  'pages.netValueSolution.list.ph.district': 'Select district',
  'pages.netValueSolution.list.ph.bank': 'Select bank',
  'pages.netValueSolution.list.ph.businessLines': 'Select business line',
  'pages.netValueSolution.list.ph.businessType': 'Select business type',
  'pages.netValueSolution.list.ph.organization': 'Select organization',
  'pages.netValueSolution.list.ph.netWorthName': 'Select net worth name',
  'pages.netValueSolution.list.paginationTotal': 'Items {start}-{end} of {total}',

  'pages.reportTemplate.list.title': 'Template config list',
  'pages.reportTemplate.list.addButton': 'Add report config',
  'pages.reportTemplate.list.loadListFailedRetry': 'Failed to load template configs. Please try again.',
  'pages.reportTemplate.list.unlimited': 'Any',
  'pages.reportTemplate.list.configTemplate': 'Configure',
  'pages.reportTemplate.list.editRules': 'Edit rules',
  'pages.reportTemplate.list.confirmDeleteTitle': 'Confirm delete',
  'pages.reportTemplate.list.confirmDeleteContent':
    'This will permanently delete the config and all versions/mappings. Continue?',
  'pages.reportTemplate.list.deleteItemLabel': 'Report template config “{name}”',
  'pages.reportTemplate.list.statusNormal': 'Normal',
  'pages.reportTemplate.list.statusEnabled': 'Active',
  'pages.reportTemplate.list.statusPending': 'Pending',
  'pages.reportTemplate.list.statusArchived': 'Archived',
  'pages.reportTemplate.list.col.templateName': 'Template name',
  'pages.reportTemplate.list.col.organization': 'Organization',
  'pages.reportTemplate.list.col.province': 'Province',
  'pages.reportTemplate.list.col.city': 'City',
  'pages.reportTemplate.list.col.district': 'District',
  'pages.reportTemplate.list.col.street': 'Street',
  'pages.reportTemplate.list.col.bank': 'Channel',
  'pages.reportTemplate.list.col.businessLines': 'Business line',
  'pages.reportTemplate.list.col.businessType': 'Business type',
  'pages.reportTemplate.list.col.businessSubType': 'Sub business type',
  'pages.reportTemplate.list.col.landRightNature': 'Land nature',
  'pages.reportTemplate.list.col.actualUse': 'Actual use',
  'pages.reportTemplate.list.col.status': 'Status',
  'pages.reportTemplate.list.col.updateTime': 'Updated at',
  'pages.reportTemplate.list.col.action': 'Actions',
  'pages.reportTemplate.list.ph.templateName': 'Enter template name',
  'pages.reportTemplate.list.ph.organization': 'Select organization',
  'pages.reportTemplate.list.ph.province': 'Select province',
  'pages.reportTemplate.list.ph.city': 'Select city',
  'pages.reportTemplate.list.ph.businessLines': 'Select business line',
  'pages.reportTemplate.list.ph.businessType': 'Select business type',
  'pages.reportTemplate.list.ph.businessSubType': 'Select sub business type',
  'pages.reportTemplate.list.ph.bank': 'Select channel',
  'pages.reportTemplate.list.ph.landRightNature': 'Enter land nature',
  'pages.reportTemplate.list.ph.actualUse': 'Select actual use',
  'pages.reportTemplate.list.ph.status': 'Select status',
  'pages.reportTemplate.list.paginationTotal': 'Items {start}-{end} of {total}',

  'pages.universalParams.title': 'Universal parameters',
  'pages.universalParams.addButton': 'Add parameter',
  'pages.universalParams.col.orderIndex': 'Order',
  'pages.universalParams.col.name': 'Name',
  'pages.universalParams.col.description': 'Description',
  'pages.universalParams.col.value': 'Value',
  'pages.universalParams.col.action': 'Actions',
  'pages.universalParams.loadListFailed': 'Failed to load list',
  'pages.universalParams.loadDetailFailed': 'Failed to load details',
  'pages.universalParams.confirmDeleteTitle': 'Confirm delete',
  'pages.universalParams.confirmDeleteDesc': 'Delete parameter “{name}”?',
  'pages.universalParams.modal.addTitle': 'Add universal parameter',
  'pages.universalParams.modal.editTitle': 'Edit universal parameter',
  'pages.universalParams.form.name': 'Name',
  'pages.universalParams.form.namePlaceholder': 'Display name',
  'pages.universalParams.form.description': 'Description',
  'pages.universalParams.form.descriptionPlaceholder': 'Optional',
  'pages.universalParams.form.value': 'Value',
  'pages.universalParams.form.valuePlaceholder': 'tb_task_record.appraisal_value',
  'pages.universalParams.form.orderIndex': 'Sort order',
  'pages.universalParams.form.orderPlaceholder': 'Smaller numbers appear first',
  'pages.universalParams.rules.nameRequired': 'Enter parameter name',
  'pages.universalParams.rules.valueRequired': 'Enter parameter value',
  'pages.universalParams.rules.valueFormat':
    'Must be tb_table.field (lowercase and underscores), e.g. tb_task_record.appraisal_value',
  'pages.universalParams.extra.valueHint':
    'PARAM keys in formulas must match: tb_ prefix table name and field, e.g. tb_task_record.value',

  'pages.system.logs.headerTitle': 'Operation logs',
  'pages.system.logs.col.modelName': 'Module',
  'pages.system.logs.col.apiName': 'Content',
  'pages.system.logs.col.userName': 'Operator',
  'pages.system.logs.col.requestIp': 'Request IP',
  'pages.system.logs.col.status': 'Status',
  'pages.system.logs.col.createTime': 'Time',
  'pages.system.logs.col.timeRange': 'Time range',
  'pages.system.logs.ph.module': 'Select module',
  'pages.system.logs.ph.userName': 'Enter operator name',
  'pages.system.logs.fetchModulesFailed': 'Failed to load operation modules',

  'pages.system.permission.addButton': 'Add permission',
  'pages.system.permission.col.name': 'Permission name',
  'pages.system.permission.col.desc': 'Description',
  'pages.system.permission.col.action': 'Actions',
  'pages.system.permission.configureApi': 'Configure API',
  'pages.system.permission.deleteItemName': 'Permission “{name}”',
  'pages.system.permission.batchSelected': '{count} permission(s) selected',
  'pages.system.permission.apiConfigSuccess': 'API permissions saved',
  'pages.system.permission.apiConfigFailed': 'Failed to save API permissions',
  'pages.system.permission.apiConfigFailedRetry': 'Failed to save API permissions. Please try again.',
  'pages.system.permission.apiModalTitle': 'Configure API permissions - {name}',
  'pages.system.permission.selectToDelete': 'Select permissions to delete',

  'pages.system.role.col.name': 'Role name',
  'pages.system.role.col.description': 'Description',
  'pages.system.role.col.action': 'Actions',
  'pages.system.role.deleteItemName': 'Role [{name}]',
  'pages.system.role.batchSelected': '{count} role(s) selected',
  'pages.system.role.configurePermission': 'Configure permissions',
  'pages.system.role.configureMenuPermission': 'Configure menu permissions',
  'pages.system.role.apiConfigSuccess': 'API permissions saved',
  'pages.system.role.permissionConfigSuccess': 'Permissions saved',
  'pages.system.role.menuPermissionConfigSuccess': 'Menu permissions saved',
  'pages.system.role.deleteFailedCount': '{count} role(s) failed to delete',

  'pages.system.menu.col.name': 'Name',
  'pages.system.menu.col.code': 'Code',
  'pages.system.menu.col.action': 'Actions',
  'pages.system.menu.addButton': 'Add menu',
  'pages.system.menu.addSubMenu': 'Add sub-menu',
  'pages.system.menu.deleteItemName': 'Menu “{name}”',

  'pages.system.dept.pageTitle': 'Departments',
  'pages.system.dept.refresh': 'Refresh',
  'pages.system.dept.addDept': 'Add department',
  'pages.system.dept.addChildDept': 'Add sub-department',
  'pages.system.dept.editDept': 'Edit department',
  'pages.system.dept.treeTitle': 'Department tree',
  'pages.system.dept.orgCount': '{count} organization(s)',
  'pages.system.dept.emptyTree': 'No department data',
  'pages.system.dept.detailDept': 'Department details',
  'pages.system.dept.detailOrg': 'Organization details',
  'pages.system.dept.edit': 'Edit',
  'pages.system.dept.delete': 'Delete',
  'pages.system.dept.label.deptName': 'Department name',
  'pages.system.dept.label.deptId': 'Department ID',
  'pages.system.dept.label.parentDept': 'Parent department',
  'pages.system.dept.label.status': 'Status',
  'pages.system.dept.label.childCount': 'Sub-departments',
  'pages.system.dept.label.ownerOrg': 'Organization / customer',
  'pages.system.dept.label.orgName': 'Organization / customer name',
  'pages.system.dept.label.orgId': 'Organization / customer ID',
  'pages.system.dept.label.ownerType': 'Type',
  'pages.system.dept.type.organization': 'Organization',
  'pages.system.dept.type.customer': 'Customer',
  'pages.system.dept.status.enabled': 'Enabled',
  'pages.system.dept.status.disabled': 'Disabled',
  'pages.system.dept.parentRoot': 'None (root)',
  'pages.system.dept.selectNodeHint': 'Select a department or organization on the left',
  'pages.system.dept.unnamedDept': 'Unnamed department',
  'pages.system.dept.ungrouped': 'Ungrouped',
  'pages.system.dept.unnamed': 'Unnamed',
  'pages.system.dept.fetchTreeFail': 'Failed to load department tree',
  'pages.system.dept.fetchTreeFailRetry': 'Failed to load department tree. Please try again later.',
  'pages.system.dept.cannotDeleteInvalid': 'Cannot delete an invalid department node',
  'pages.system.dept.cannotDeleteRoot': 'Root department cannot be deleted',
  'pages.system.dept.defaultItemName': 'department',
  'pages.system.dept.deleteTitle': 'Delete this department?',
  'pages.system.dept.deleteContent':
    'This cannot be undone. Sub-departments under it will be affected.',
  'pages.system.dept.deleteSuccess': 'Deleted',
  'pages.system.dept.deleteFail': 'Delete failed',
  'pages.system.dept.deleteFailRetry': 'Delete failed. Please try again.',
  'pages.system.dept.editMissingOwner': 'Missing organization/customer for this department. Refresh and try again.',
  'pages.system.dept.saveSuccessEdit': 'Department updated',
  'pages.system.dept.saveSuccessAdd': 'Department created',
  'pages.system.dept.saveFail': 'Save failed',
  'pages.system.dept.form.name': 'Department name',
  'pages.system.dept.form.nameRequired': 'Enter department name',
  'pages.system.dept.form.nameMax': 'Name must be 50 characters or less',
  'pages.system.dept.form.namePlaceholder': 'Enter department name',
  'pages.system.dept.form.ownerOrg': 'Organization',
  'pages.system.dept.form.ownerOrgRequired': 'Select an organization',
  'pages.system.dept.form.ownerOrgPlaceholder': 'Select an organization',
  'pages.system.dept.form.ownerOrgCustomer': 'Organization / customer',
  'pages.system.dept.form.ownerSelectedPlaceholder': 'Selected organization / customer',
  'pages.system.dept.form.parentDept': 'Parent department',
  'pages.system.dept.form.parentDeptPlaceholder': 'Select parent department',

  'pages.system.district.pageTitle': 'Administrative Districts',
  'pages.system.district.refresh': 'Refresh',
  'pages.system.district.treeTitle': 'District tree',
  'pages.system.district.nodeCount': '{count} root node(s)',
  'pages.system.district.treeSearchPlaceholder': 'Search by name or adcode',
  'pages.system.district.treeSearchEmpty': 'No matching districts',
  'pages.system.district.emptyTree': 'No district data',
  'pages.system.district.detailTitle': 'District details',
  'pages.system.district.label.name': 'District name',
  'pages.system.district.label.adcode': 'Adcode',
  'pages.system.district.label.level': 'Level',
  'pages.system.district.label.parentDistrict': 'Parent district',
  'pages.system.district.label.dataSource': 'Data source',
  'pages.system.district.label.status': 'Status',
  'pages.system.district.label.sortOrder': 'Sort order',
  'pages.system.district.label.childCount': 'Children count',
  'pages.system.district.level.province': 'Province',
  'pages.system.district.level.city': 'City',
  'pages.system.district.level.district': 'District / County',
  'pages.system.district.level.street': 'Street',
  'pages.system.district.dataSource.amap': 'Synced from AMap',
  'pages.system.district.dataSource.manual': 'Manual',
  'pages.system.district.status.enabled': 'Enabled',
  'pages.system.district.status.disabled': 'Disabled',
  'pages.system.district.parentRoot': 'None (root)',
  'pages.system.district.selectNodeHint': 'Select a district node on the left',
  'pages.system.district.unnamed': 'Unnamed district',
  'pages.system.district.fetchTreeFail': 'Failed to load district tree',
  'pages.system.district.fetchTreeFailRetry': 'Failed to load district tree. Please try again later.',
  'pages.system.district.fetchStreetsFailRetry': 'Failed to load streets. Please try again later.',
  'pages.system.district.invalidParentLevel': 'Invalid parent level. Please select again.',
  'pages.system.district.addDistrict': 'Add district',
  'pages.system.district.addChildDistrict': 'Add sub-district',
  'pages.system.district.editDistrict': 'Edit district',
  'pages.system.district.edit': 'Edit',
  'pages.system.district.delete': 'Delete',
  'pages.system.district.cannotDeleteInvalid': 'Cannot delete an invalid district node',
  'pages.system.district.cannotDeleteHasChildren': 'Cannot delete a district that has children',
  'pages.system.district.cannotAddChildStreet': 'Street-level districts cannot have children',
  'pages.system.district.defaultItemName': 'district',
  'pages.system.district.deleteTitle': 'Delete this district?',
  'pages.system.district.deleteContent': 'This cannot be undone. Please confirm.',
  'pages.system.district.deleteSuccess': 'Deleted',
  'pages.system.district.deleteFail': 'Delete failed',
  'pages.system.district.deleteFailRetry': 'Delete failed. Please try again.',
  'pages.system.district.editMissingId': 'Missing district ID for edit. Refresh and try again.',
  'pages.system.district.saveSuccessEdit': 'District updated',
  'pages.system.district.saveSuccessAdd': 'District created',
  'pages.system.district.saveFail': 'Save failed',
  'pages.system.district.form.name': 'District name',
  'pages.system.district.form.nameRequired': 'Enter district name',
  'pages.system.district.form.nameMax': 'Name must be 100 characters or less',
  'pages.system.district.form.namePlaceholder': 'Enter district name',
  'pages.system.district.form.level': 'Level',
  'pages.system.district.form.levelRequired': 'Select a level',
  'pages.system.district.form.levelPlaceholder': 'Select a level',
  'pages.system.district.form.parentDistrict': 'Parent district',
  'pages.system.district.form.parentRequired': 'Select a parent district',
  'pages.system.district.form.parentPlaceholder': 'Select a parent district',
  'pages.system.district.form.status': 'Status',
  'pages.system.district.form.sortOrder': 'Sort order',
  'pages.system.district.form.provinceShortName': 'Province short name',
  'pages.system.district.form.provinceShortNamePlaceholder': 'Enter province short name',
  'pages.system.district.form.citycode': 'City code',
  'pages.system.district.form.citycodePlaceholder': 'Enter city code',
  'pages.system.district.form.plateNumber': 'Plate number',
  'pages.system.district.form.plateNumberPlaceholder': 'Enter plate number',
  'pages.system.district.form.center': 'Center coordinates',
  'pages.system.district.form.centerPlaceholder': 'Format: longitude,latitude',
  'pages.system.district.form.polyline': 'Boundary coordinates',
  'pages.system.district.form.polylinePlaceholder': 'Enter boundary coordinates',

  'pages.operations.statTotalCustomers': 'Total customers',
  'pages.operations.statNewThisMonth': 'New this month',
  'pages.operations.statPendingTasks': 'Pending tasks',
  'pages.operations.statReportsDone': 'Reports completed',
  'pages.operations.taskRateTitle': 'Task completion',
  'pages.operations.recentActivityTitle': 'Recent activity',
  'pages.operations.col.time': 'Time',
  'pages.operations.col.activity': 'Activity',
  'pages.operations.col.operator': 'Operator',
  'pages.operations.col.status': 'Status',
  'pages.operations.taskName.evaluation': 'Customer evaluation',
  'pages.operations.taskName.report': 'Report generation',
  'pages.operations.taskName.finance': 'Finance review',
  'pages.operations.taskName.maintenance': 'System maintenance',
  'pages.operations.status.done': 'Done',
  'pages.operations.status.inProgress': 'In progress',
  'pages.operations.systemStatusTitle': 'System status',
  'pages.operations.cpuUsage': 'CPU usage',
  'pages.operations.memoryUsage': 'Memory usage',
  'pages.operations.diskUsage': 'Disk usage',
  'pages.operations.demo.action1': 'New customer evaluation task',
  'pages.operations.demo.action2': 'Finance report review completed',
  'pages.operations.demo.action3': 'System maintenance update',
  'pages.operations.demo.action4': 'Customer satisfaction survey',
  'pages.operations.demo.user1': 'Zhang',
  'pages.operations.demo.user2': 'Li',
  'pages.operations.demo.user3': 'Wang',
  'pages.operations.demo.user4': 'Zhao',

  'pages.finance.tooltip.view': 'View',
  'pages.finance.tooltip.edit': 'Edit',
  'pages.finance.tooltip.delete': 'Delete',
  'pages.finance.stat.totalIncome': 'Total income',
  'pages.finance.stat.totalExpense': 'Total expense',
  'pages.finance.stat.netIncome': 'Net income',
  'pages.finance.modal.add': 'Add finance record',
  'pages.finance.modal.edit': 'Edit finance record',
  'pages.finance.addRecord': 'Add record',
  'pages.finance.paginationTotal': 'Items {start}-{end} of {total}',

  'pages.platform.tooltip.view': 'View',
  'pages.platform.tooltip.edit': 'Edit',
  'pages.platform.tooltip.delete': 'Delete',
  'pages.platform.modal.add': 'Add maintenance record',
  'pages.platform.modal.edit': 'Edit maintenance record',
  'pages.platform.addRecord': 'Add maintenance',
  'pages.platform.paginationTotal': '{total} records',
  'pages.platform.column.id': 'ID',
  'pages.platform.column.title': 'Title',
  'pages.platform.column.type': 'Type',
  'pages.platform.column.priority': 'Priority',
  'pages.platform.column.status': 'Status',
  'pages.platform.column.progress': 'Progress',
  'pages.platform.column.assignee': 'Assignee',
  'pages.platform.column.createTime': 'Created',
  'pages.platform.column.estimatedTime': 'Est. completion',
  'pages.platform.column.action': 'Actions',
  'pages.platform.overview.ok': 'System OK',
  'pages.platform.overview.running': 'Running',
  'pages.platform.overview.attention': 'Attention',
  'pages.platform.overview.error': 'Error',
  'pages.platform.alert.title': 'System status',
  'pages.platform.alert.cpu': 'CPU',
  'pages.platform.alert.memory': 'Memory',
  'pages.platform.alert.disk': 'Disk',
  'pages.platform.alert.network': 'Network',
  'pages.platform.alert.networkOk': 'OK',
  'pages.platform.filter.searchPlaceholder': 'Search title or description',
  'pages.platform.filter.typePlaceholder': 'Type',
  'pages.platform.filter.statusPlaceholder': 'Status',
  'pages.platform.filter.priorityPlaceholder': 'Priority',
  'pages.platform.filter.assigneePlaceholder': 'Filter by assignee',
  'pages.platform.type.all': 'All types',
  'pages.platform.type.performance': 'Performance',
  'pages.platform.type.security': 'Security',
  'pages.platform.type.hardware': 'Hardware',
  'pages.platform.status.all': 'All statuses',
  'pages.platform.status.pending': 'Pending',
  'pages.platform.status.ongoing': 'In progress',
  'pages.platform.status.completed': 'Completed',
  'pages.platform.priority.all': 'All priorities',
  'pages.platform.priority.high': 'High',
  'pages.platform.priority.medium': 'Medium',
  'pages.platform.priority.low': 'Low',
  'pages.platform.stat.total': 'Total records',
  'pages.platform.stat.completed': 'Completed',
  'pages.platform.stat.inProgress': 'In progress',
  'pages.platform.stat.pending': 'Pending',
  'pages.platform.confirmDelete': 'Confirm delete',
  'pages.platform.confirmDeleteContent': 'Delete maintenance record "{title}"?',
  'pages.platform.msg.deleteSuccess': 'Deleted',
  'pages.platform.msg.updateSuccess': 'Updated',
  'pages.platform.msg.addSuccess': 'Added',
  'pages.platform.form.title': 'Title',
  'pages.platform.form.titleRequired': 'Enter title',
  'pages.platform.form.titlePlaceholder': 'Enter title',
  'pages.platform.form.type': 'Type',
  'pages.platform.form.typeRequired': 'Select type',
  'pages.platform.form.typePerformance': 'Performance',
  'pages.platform.form.typeSecurity': 'Security',
  'pages.platform.form.typeHardware': 'Hardware',
  'pages.platform.form.typeSoftware': 'Software update',
  'pages.platform.form.priority': 'Priority',
  'pages.platform.form.priorityRequired': 'Select priority',
  'pages.platform.form.assignee': 'Assignee',
  'pages.platform.form.assigneeRequired': 'Enter assignee',
  'pages.platform.form.assigneePlaceholder': 'Enter assignee',
  'pages.platform.form.estimatedTime': 'Est. completion',
  'pages.platform.form.estimatedTimeRequired': 'Select date',
  'pages.platform.form.estimatedTimePlaceholder': 'e.g. 2024-01-20',
  'pages.platform.form.description': 'Description',
  'pages.platform.form.descriptionRequired': 'Enter description',
  'pages.platform.form.descriptionPlaceholder': 'Enter description',
  'pages.platform.form.status': 'Status',

  'pages.activity.tooltip.view': 'View',
  'pages.activity.tooltip.edit': 'Edit',
  'pages.activity.tooltip.delete': 'Delete',
  'pages.activity.modal.add': 'Add activity',
  'pages.activity.modal.edit': 'Edit activity',
  'pages.activity.addRecord': 'Add activity',
  'pages.activity.paginationTotal': '{total} records',
  'pages.activity.column.id': 'Activity ID',
  'pages.activity.column.title': 'Title',
  'pages.activity.column.type': 'Type',
  'pages.activity.column.startTime': 'Start time',
  'pages.activity.column.endTime': 'End time',
  'pages.activity.column.location': 'Location',
  'pages.activity.column.status': 'Status',
  'pages.activity.column.participants': 'Participants',
  'pages.activity.column.budget': 'Budget',
  'pages.activity.column.organizer': 'Organizer',
  'pages.activity.column.action': 'Actions',
  'pages.activity.stat.total': 'Total activities',
  'pages.activity.stat.inProgress': 'In progress',
  'pages.activity.stat.registering': 'Registration open',
  'pages.activity.stat.ended': 'Ended',
  'pages.activity.filter.searchPlaceholder': 'Search by title or organizer',
  'pages.activity.filter.typePlaceholder': 'Type',
  'pages.activity.filter.statusPlaceholder': 'Status',
  'pages.activity.filter.locationPlaceholder': 'Filter by location',
  'pages.activity.type.all': 'All types',
  'pages.activity.type.customer': 'Customer event',
  'pages.activity.type.training': 'Training',
  'pages.activity.type.meeting': 'Internal meeting',
  'pages.activity.status.all': 'All statuses',
  'pages.activity.status.planning': 'Planning',
  'pages.activity.status.registration': 'Registration open',
  'pages.activity.status.ongoing': 'In progress',
  'pages.activity.status.ended': 'Ended',
  'pages.activity.rangeStart': 'Start date',
  'pages.activity.rangeEnd': 'End date',
  'pages.activity.confirmDelete': 'Confirm delete',
  'pages.activity.confirmDeleteContent': 'Delete activity "{title}"?',
  'pages.activity.msg.deleteSuccess': 'Deleted',
  'pages.activity.msg.updateSuccess': 'Updated',
  'pages.activity.msg.addSuccess': 'Added',
  'pages.activity.form.title': 'Title',
  'pages.activity.form.titleRequired': 'Enter title',
  'pages.activity.form.titlePlaceholder': 'Enter title',
  'pages.activity.form.type': 'Type',
  'pages.activity.form.typeRequired': 'Select type',
  'pages.activity.form.organizer': 'Organizer',
  'pages.activity.form.organizerRequired': 'Enter organizer',
  'pages.activity.form.organizerPlaceholder': 'Enter organizer',
  'pages.activity.form.startTime': 'Start time',
  'pages.activity.form.startTimeRequired': 'Select start time',
  'pages.activity.form.endTime': 'End time',
  'pages.activity.form.endTimeRequired': 'Select end time',
  'pages.activity.form.location': 'Location',
  'pages.activity.form.locationRequired': 'Enter location',
  'pages.activity.form.locationPlaceholder': 'Enter location',
  'pages.activity.form.maxParticipants': 'Max participants',
  'pages.activity.form.maxParticipantsRequired': 'Enter max participants',
  'pages.activity.form.budget': 'Budget',
  'pages.activity.form.budgetRequired': 'Enter budget',
  'pages.activity.form.activityStatus': 'Status',

  'pages.customer.list.col.customerName': 'Customer name',
  'pages.customer.list.col.customerType': 'Customer type',
  'pages.customer.list.col.province': 'Province',
  'pages.customer.list.col.city': 'City',
  'pages.customer.list.col.district': 'District',
  'pages.customer.list.col.organization': 'Organization',
  'pages.customer.list.col.status': 'Status',
  'pages.customer.list.col.totalAmountPrecision': 'Price precision',
  'pages.customer.list.col.contact': 'Contacts',
  'pages.customer.list.col.contactPhone': 'Contact phone',
  'pages.customer.list.col.createTime': 'Created at',
  'pages.customer.list.col.updateTime': 'Updated at',
  'pages.customer.list.col.action': 'Actions',
  'pages.customer.list.confirmToggleTitle': 'Confirm {action}',
  'pages.customer.list.confirmToggleContent': 'Are you sure you want to {action} this customer?',
  'pages.customer.list.itemNamed': 'Customer "{name}"',
  'pages.customer.list.batchItemName': '{count} selected customer(s)',
  'pages.customer.list.batchContent':
    'This cannot be undone. Delete the selected customers?',
  'pages.customer.list.batchResultAllSuccess': 'Deleted {success} customer(s)',
  'pages.customer.list.batchResultPartial': 'Deleted {success} customer(s), {fail} failed',
  'pages.customer.list.batchFailed': 'Batch delete failed',
  'pages.customer.list.exportOrgTemplate': 'Organization customer template',
  'pages.customer.list.exportPersonalTemplate': 'Individual customer template',
  'pages.customer.list.exportUserTemplate': 'Customer user template',
  'pages.customer.list.exportTemplate': 'Download template',
  'pages.customer.list.importCustomer': 'Import customers',
  'pages.customer.list.importCustomerUser': 'Import customer users',
  'pages.customer.list.addCustomer': 'Add customer',
  'pages.customer.list.fileNameOrgTemplate': 'organization-customer-import.xlsx',
  'pages.customer.list.fileNamePersonalTemplate': 'personal-customer-import.xlsx',
  'pages.customer.list.fileNameUserTemplate': 'customer-user-import.xlsx',
  'pages.customer.list.deleteContent':
    'This cannot be undone. Delete this customer?',
  'pages.customer.list.toggleSuccess': '{action} succeeded',
  'pages.customer.list.toggleFail': '{action} failed',
  'pages.customer.list.batchAmountPrecision': 'Edit price precision ({count})',
  'pages.customer.list.amountPrecisionBatchTitle': 'Batch edit total amount precision',
  'pages.customer.list.amountPrecisionBatchHint': '{count} customer(s) selected',
  'pages.customer.list.amountPrecisionConfigMode': 'Configuration',
  'pages.customer.list.amountPrecisionModeSet': 'Set precision',
  'pages.customer.list.amountPrecisionModeClear': 'Clear customer configuration',
  'pages.customer.list.amountPrecisionRequired': 'Please select total amount precision',
  'pages.customer.list.amountPrecisionNoCustomers': 'No valid customers selected',
  'pages.customer.list.amountPrecisionBatchSuccess': 'Updated precision for {count} customer(s)',
  'pages.customer.list.amountPrecisionBatchPartial': 'Updated {success} customer(s), {fail} failed',
  'pages.customer.list.amountPrecisionBatchFailed': 'Failed to batch update price precision',
  'pages.customer.list.amountPrecisionFailReason': 'Failure reason',

  'pages.taskMgmt.col.taskNumber': 'Task number',
  'pages.taskMgmt.col.reportNumber': 'Report number',
  'pages.taskMgmt.col.taskName': 'Task name',
  'pages.taskMgmt.col.specialSituation': 'Special situation',
  'pages.taskMgmt.col.taskStatus': 'Task status',
  'pages.taskMgmt.col.creator': 'Creator',
  'pages.taskMgmt.col.currentOperator': 'Current operator',
  'pages.taskMgmt.col.province': 'Province',
  'pages.taskMgmt.col.city': 'City',
  'pages.taskMgmt.col.district': 'District',
  'pages.taskMgmt.col.createTime': 'Created at',
  'pages.taskMgmt.col.action': 'Actions',
  'pages.taskMgmt.action.view': 'View',
  'pages.taskMgmt.action.edit': 'Edit',
  'pages.taskMgmt.action.withdraw': 'Withdraw',
  'pages.taskMgmt.withdrawTitle': 'Withdraw price review',
  'pages.taskMgmt.withdrawConfirm': 'Confirm withdraw',
  'pages.taskMgmt.withdrawSuccess': 'Price review withdrawn',
  'pages.taskMgmt.withdrawCheckFail': 'Failed to check withdraw eligibility',
  'pages.taskMgmt.withdrawCheckFailRetry': 'Failed to check withdraw eligibility. Please try again.',
  'pages.taskMgmt.withdrawFail': 'Failed to withdraw price review',
  'pages.taskMgmt.withdrawFailRetry': 'Failed to withdraw price review. Please try again.',
  'pages.taskMgmt.withdrawNotAllowedTitle': 'Withdraw not allowed',
  'pages.taskMgmt.withdrawNotAllowedDefault': 'This task cannot withdraw price review in its current state',
  'pages.taskMgmt.withdrawApproverLabel': 'Approver',
  'pages.taskMgmt.withdrawApproverPlaceholder': 'Search by name or select a department manager',
  'pages.taskMgmt.withdrawApproverRequired': 'Please select an approver',
  'pages.taskMgmt.withdrawApproverNotFound': 'No matching approver found',
  'pages.taskMgmt.withdrawCommentLabel': 'Comment',
  'pages.taskMgmt.withdrawCommentPlaceholder': 'Enter withdrawal reason',
  'pages.taskMgmt.withdrawCommentRequired': 'Withdrawal reason is required',
  'pages.taskMgmt.unknownStatus': 'Unknown status',
  'pages.taskMgmt.createLoading': 'Creating task…',
  'pages.taskMgmt.createFail': 'Failed to create task. Please try again.',
  'pages.taskMgmt.deleteTitle': 'Confirm delete',
  'pages.taskMgmt.deleteContent': 'Delete task "{name}"?',
  'pages.taskMgmt.noTaskId': 'Task ID missing; cannot delete',
  'pages.taskMgmt.redoTitle': 'Confirm redo',
  'pages.taskMgmt.redoContent': 'Redo task "{name}"?',
  'pages.taskMgmt.redoSuccess': 'Task redone',
  'pages.taskMgmt.fetchListFail': 'Failed to load task list',
  'pages.taskMgmt.fetchListFailRetry': 'Failed to load task list. Please try again.',
  'pages.taskMgmt.modalAddTitle': 'New task',
  'pages.taskMgmt.formTaskName': 'Task name',
  'pages.taskMgmt.formTaskNameMax': 'Name must be 100 characters or less',
  'pages.taskMgmt.formTaskNamePlaceholder': 'Task name (optional)',
  'pages.taskMgmt.paginationTotal': 'Items {start}-{end} of {total}',

  'pages.report.col.electronicCode': 'Electronic report code',
  'pages.report.col.estimateCode': 'Report number',
  'pages.report.col.taskName': 'Task name',
  'pages.report.col.state': 'Status',
  'pages.report.col.creator': 'Creator',
  'pages.report.col.operator': 'Current operator',
  'pages.report.col.organization': 'Organization',
  'pages.report.col.province': 'Province',
  'pages.report.col.city': 'City',
  'pages.report.col.district': 'District',
  'pages.report.col.createTime': 'Created at',
  'pages.report.col.action': 'Actions',
  'pages.report.state.all': 'All',
  'pages.report.state.pendingFirst': 'First review pending',
  'pages.report.state.pendingSecond': 'Second review pending',
  'pages.report.state.pendingThird': 'Third review pending',
  'pages.report.state.pendingSeal': 'Pending seal',
  'pages.report.state.pendingModify': 'Pending modification',
  'pages.report.state.done': 'Completed',
  'pages.report.state.pendingArchive': 'Pending archive',
  'pages.report.state.void': 'Void',
  'pages.report.state.completedEnd': 'Closed',
  'pages.report.state.pendingReview': 'Pending review',
  'pages.report.state.reviewed': 'Reviewed',
  'pages.report.state.sealPending': 'Pending seal',
  'pages.report.state.sealed': 'Sealed',
  'pages.report.process.pending': 'Pending',
  'pages.report.process.done': 'Processed',
  'pages.report.review.addDev': 'New report feature is under development…',
  'pages.report.action.review': 'Review',
  'pages.report.action.sign': 'Sign',

  'pages.ledger.list.title': 'Ledger records',
  'pages.ledger.list.fetchFail': 'Failed to load ledger list',
  'pages.ledger.list.directConnect': 'Direct connect',
  'pages.ledger.list.tokenRequired': 'Enter third-party platform token',
  'pages.ledger.list.syncFail': 'Sync failed',
  'pages.ledger.list.directConnectDone': 'Direct connect completed',
  'pages.ledger.list.directConnectAlready': 'This ledger already completed direct connect',
  'pages.ledger.list.initFail': 'Initialization failed',
  'pages.ledger.list.initNoFileId': 'Initialization did not return fileId; cannot save binding',
  'pages.ledger.list.saveBindFail': 'Save and bind failed',
  'pages.ledger.list.flowFail': 'Handover review failed',
  'pages.ledger.list.flowTimeout': 'Review workflow timed out. Please try again later.',
  'pages.ledger.list.editDirectFail': 'Edit and direct connect failed',
  'pages.ledger.list.searchConfigSaved': 'Search field configuration saved',
  'pages.ledger.list.ph.province': 'Select province',
  'pages.ledger.list.ph.city': 'Select city',
  'pages.ledger.list.ph.district': 'Select district',
  'pages.ledger.list.ph.street': 'Select street',
  'pages.ledger.list.notFoundData': 'No data',
  'pages.ledger.list.notFoundSelectProvince': 'Select province first',
  'pages.ledger.list.notFoundSelectCity': 'Select city first',
  'pages.ledger.list.notFoundSelectDistrict': 'Select district first',
  'pages.ledger.list.downloadTemplate': 'Downloading template…',
  'pages.ledger.list.templateFileName': 'ledger-import-template.xlsx',
  'pages.ledger.list.exporting': 'Exporting…',
  'pages.ledger.list.exportSuccess': 'Export succeeded',
  'pages.ledger.list.exportFail': 'Export failed',

  'pages.ledger.list.batchDirectConnect': 'Batch direct connect',
  'pages.ledger.list.autoDirectConnect': 'Auto direct connect',
  'pages.ledger.list.batchDirectConnectHint': 'Start batch direct connect for {count} eligible record(s)',
  'pages.ledger.list.autoDirectConnectHint': 'The system will auto-select pending records; scope is determined by the backend',
  'pages.ledger.list.directConnectTokenLabel': 'User token (required)',
  'pages.ledger.list.batchDirectConnectSkipped': 'Skipped {count} ineligible record(s)',
  'pages.ledger.list.batchDirectConnectNoEligible': 'No eligible records to connect',
  'pages.ledger.list.batchDirectConnectStartFail': 'Failed to start batch direct connect',
  'pages.ledger.list.autoDirectConnectStartFail': 'Failed to start auto direct connect',
  'pages.ledger.list.autoDirectConnectNoRecords': 'No pending records to connect',
  'pages.ledger.list.directConnectSkippedCount': '{count} record(s) were skipped',
  'pages.ledger.list.directConnectJobTitle': 'Direct connect progress',
  'pages.ledger.list.directConnectTaskList': 'Direct connect jobs',
  'pages.ledger.list.directConnectTaskListTitle': 'Direct connect job list',
  'pages.ledger.list.directConnectTaskListView': 'View progress',
  'pages.ledger.list.directConnectTaskListEmpty': 'No direct connect jobs',
  'pages.ledger.list.directConnectTaskType.BATCH': 'Batch',
  'pages.ledger.list.directConnectTaskType.AUTO': 'Auto',
  'pages.ledger.list.directConnectJobStatusLabel': 'Job status',
  'pages.ledger.list.directConnectJobTotal': 'Total',
  'pages.ledger.list.directConnectJobSuccess': 'Success',
  'pages.ledger.list.directConnectJobFailed': 'Failed',
  'pages.ledger.list.directConnectJobSkipped': 'Skipped',
  'pages.ledger.list.directConnectJobProcessing': 'In progress',
  'pages.ledger.list.directConnectJobEmpty': 'No details',
  'pages.ledger.list.directConnectJobCompleted': 'Direct connect job completed successfully',
  'pages.ledger.list.directConnectJobPartialFailed': 'Direct connect job partially failed',
  'pages.ledger.list.directConnectJobFailedMessage': 'Direct connect job failed',
  'pages.ledger.list.directConnectJobCancelled': 'Direct connect job cancelled',
  'pages.ledger.list.directConnectJobQueryFail': 'Failed to query direct connect progress',
  'pages.ledger.list.directConnectJobCloseTitle': 'Job still running',
  'pages.ledger.list.directConnectJobCloseContent': 'The job will continue in the background. Close this window?',
  'pages.ledger.list.directConnectCancelTask': 'Cancel queued job',
  'pages.ledger.list.directConnectCancelSuccess': 'Job cancelled',
  'pages.ledger.list.directConnectCancelFailed': 'Job already started and cannot be cancelled',
  'pages.ledger.list.directConnectTokenDigest': 'Token digest',
  'pages.ledger.list.directConnectCol.ledgerRecordId': 'Ledger ID',
  'pages.ledger.list.directConnectCol.taskId': 'Task ID',
  'pages.ledger.list.directConnectCol.taskType': 'Job type',
  'pages.ledger.list.directConnectCol.createTime': 'Created at',
  'pages.ledger.list.directConnectCol.status': 'Status',
  'pages.ledger.list.directConnectCol.failureType': 'Failure type',
  'pages.ledger.list.directConnectCol.failureReason': 'Failure reason',
  'pages.ledger.list.directConnectTaskStatus.QUEUED': 'Queued',
  'pages.ledger.list.directConnectTaskStatus.RUNNING': 'Running',
  'pages.ledger.list.directConnectTaskStatus.CANCELLED': 'Cancelled',
  'pages.ledger.list.directConnectTaskStatus.SUCCESS': 'All succeeded',
  'pages.ledger.list.directConnectTaskStatus.PARTIAL_FAILED': 'Partially failed',
  'pages.ledger.list.directConnectTaskStatus.FAILED': 'All failed',
  'pages.ledger.list.directConnectItemStatus.QUEUED': 'Queued',
  'pages.ledger.list.directConnectItemStatus.RUNNING': 'Running',
  'pages.ledger.list.directConnectItemStatus.SUCCESS': 'Success',
  'pages.ledger.list.directConnectItemStatus.FAILED': 'Failed',
  'pages.ledger.list.directConnectItemStatus.SKIPPED': 'Skipped',
  'pages.ledger.list.directConnectFailureType.TOKEN_INVALID': 'Invalid token',
  'pages.ledger.list.directConnectFailureType.DUPLICATE_ELECTRONIC_REPORT_CODE': 'Duplicate e-report code',
  'pages.ledger.list.directConnectFailureType.RAS_ERROR': 'RAS platform error',
  'pages.ledger.list.directConnectFailureType.SYSTEM_ERROR': 'System error',

  'pages.system.user.col.username': 'Username',
  'pages.system.user.col.workNo': 'Employee ID',
  'pages.system.user.col.realName': 'Name',
  'pages.system.user.ph.realName': 'Search by name',
  'pages.system.user.col.email': 'Email',
  'pages.system.user.col.phone': 'Phone',
  'pages.system.user.selectToDelete': 'Select users to delete',
  'pages.system.user.batchDeleteFail': 'Batch delete failed',
  'pages.system.user.downloadTemplateLoading': 'Downloading template…',
  'pages.system.user.templateFileName': 'user-import-template.xlsx',
  'pages.system.user.templateDownloadSuccess': 'Template downloaded',
  'pages.system.user.templateDownloadFail': 'Download failed. Please try again.',
  'pages.system.user.uploadExcelOnly': 'Please upload an Excel file (.xlsx or .xls)',
  'pages.system.user.fileTooLarge': 'File size must not exceed 10MB',
  'pages.system.user.importDone': 'Import finished',
  'pages.system.user.importFail': 'Import failed',
  'pages.system.user.importFailRetry': 'Import failed. Please try again.',
  'pages.system.user.resetPwdTitle': 'Reset password?',
  'pages.system.user.resetPwdContent': 'Reset password for "{name}"?',
  'pages.system.user.resetPwdOk': 'Reset',
  'pages.system.user.resetPwdSuccess': 'Password reset',
  'pages.system.user.resetPwdFail': 'Password reset failed',
  'pages.system.user.resetPwdFailRetry': 'Password reset failed. Please try again.',

  'pages.system.user.col.nickname': 'Nickname',
  'pages.system.user.ph.nickname': 'Search by nickname',
  'pages.system.user.col.gender': 'Gender',
  'pages.system.user.gender.male': 'Male',
  'pages.system.user.gender.female': 'Female',
  'pages.system.user.gender.unknown': 'Unknown',
  'pages.system.user.col.roles': 'Roles',
  'pages.system.user.unassigned': 'Unassigned',
  'pages.system.user.col.organization': 'Organization',
  'pages.system.user.ph.organization': 'Select organization',
  'pages.system.user.col.dept': 'Department',
  'pages.system.user.ph.dept': 'Select department',
  'pages.system.user.col.status': 'Status',
  'pages.system.user.col.createTime': 'Created at',
  'pages.system.user.col.action': 'Actions',
  'pages.system.user.action.edit': 'Edit',
  'pages.system.user.action.resetPwd': 'Reset password',
  'pages.system.user.action.delete': 'Delete',
  'pages.system.user.exportTemplate': 'Export template',
  'pages.system.user.import': 'Import',
  'pages.system.user.addUser': 'Add user',
  'pages.system.user.deleteSuccess': 'Deleted',
  'pages.system.user.deleteFail': 'Delete failed',
  'pages.system.user.confirmToggleTitle': 'Confirm {action}',
  'pages.system.user.confirmToggleContent': 'Are you sure you want to {action} this user?',
  'pages.system.user.userNamed': 'User "{name}"',
  'pages.system.user.userBracketNamed': 'User [{name}]',
  'pages.system.user.batchUsers': '{count} selected user(s)',
  'pages.system.user.deleteBatchSuccess': 'Deleted {count} user(s)',
  'pages.system.user.resetPwdContentInitial':
    'Reset this user’s password to the initial password?',
  'pages.system.user.tableSelected': '{count} selected',
  'pages.system.user.batchDeleteWithCount': 'Batch delete ({count})',
  'pages.system.user.cancelSelection': 'Clear selection',
  'pages.system.user.importModalTitle': 'Import users',
  'pages.system.user.importProcessingFile': 'Processing file…',
  'pages.system.user.importDragText': 'Click or drag a file here to upload',
  'pages.system.user.importFileHintLong':
    'Single Excel file: .xlsx or .xls, up to 10MB',
  'pages.system.user.importRunning': 'Importing users…',
  'pages.system.user.importRunningHint': 'Please wait; results will appear when done',
  'pages.system.user.importInstructionsTitle': 'Import notes',
  'pages.system.user.importInstruction1': 'Download the template and fill users as required',
  'pages.system.user.importInstruction2': 'Required: username, name, email, phone',
  'pages.system.user.importInstruction3': 'Gender: male/female/unknown or 1/2/3',
  'pages.system.user.importInstruction4': 'Use correct role and organization names',
  'pages.system.user.importInstruction5': 'On errors, a failure file may be available to download',
  'pages.system.user.deptUnnamed': 'Unnamed department',

  // Batch inquiry
  'pages.inquiryBatch.downloadTemplate': 'Download template',
  'pages.inquiryBatch.uploadExcel': 'Upload Excel',
  'pages.inquiryBatch.downloadingTemplate': 'Downloading template…',
  'pages.inquiryBatch.templateDownloadSuccess': 'Template downloaded',
  'pages.inquiryBatch.templateDownloadFail': 'Template download failed',
  'pages.inquiryBatch.uploadModalTitle': 'Upload batch inquiry Excel',
  'pages.inquiryBatch.uploadStart': 'Start inquiry',
  'pages.inquiryBatch.uploadDragText': 'Click or drag a file here to upload',
  'pages.inquiryBatch.uploadFileHint': '.xlsx / .xls, up to 10MB, max 500 rows per upload',
  'pages.inquiryBatch.uploadInstruction1': 'Download the template and fill all 17 columns before upload',
  'pages.inquiryBatch.uploadInstruction2': 'Only total building area is used for valuation; defaults to 100㎡ if empty',
  'pages.inquiryBatch.uploadInstruction3': 'Cannot start a new task while another is in progress',
  'pages.inquiryBatch.uploadExcelOnly': 'Excel files only',
  'pages.inquiryBatch.uploadSizeLimit': 'File size must be under 10MB',
  'pages.inquiryBatch.uploadSelectFile': 'Please select a file',
  'pages.inquiryBatch.uploadFail': 'Upload failed',
  'pages.inquiryBatch.uploadSuccess': 'Task created and processing',
  'pages.inquiryBatch.viewExistingTask': 'View in-progress task',
  'pages.inquiryBatch.viewProgress': 'View progress',
  'pages.inquiryBatch.downloadResult': 'Download result',
  'pages.inquiryBatch.resultDownloadSuccess': 'Result file downloaded',
  'pages.inquiryBatch.resultDownloadFail': 'Result download failed',
  'pages.inquiryBatch.jobTitle': 'Batch inquiry progress',
  'pages.inquiryBatch.jobCloseTitle': 'Task still running',
  'pages.inquiryBatch.jobCloseContent': 'The task continues in the background. Close anyway?',
  'pages.inquiryBatch.jobCompletedSuccess': 'Batch inquiry completed successfully',
  'pages.inquiryBatch.jobCompletedPartial': 'Batch inquiry partially completed; download result for failures',
  'pages.inquiryBatch.jobCompletedFailed': 'Batch inquiry failed for all rows',
  'pages.inquiryBatch.pollFail': 'Failed to fetch task progress',
  'pages.inquiryBatch.failureItemsTitle': 'Failed rows',
  'pages.inquiryBatch.failureItemsEmpty': 'No failed rows',
  'pages.inquiryBatch.col.inquiryBatchId': 'Task ID',
  'pages.inquiryBatch.col.status': 'Status',
  'pages.inquiryBatch.col.totalCount': 'Total rows',
  'pages.inquiryBatch.col.processedCount': 'Processed',
  'pages.inquiryBatch.col.successCount': 'Success',
  'pages.inquiryBatch.col.failureCount': 'Failed',
  'pages.inquiryBatch.col.pendingCount': 'Pending',
  'pages.inquiryBatch.col.progressPercent': 'Progress',
  'pages.inquiryBatch.col.startTime': 'Start time',
  'pages.inquiryBatch.col.endTime': 'End time',
  'pages.inquiryBatch.col.action': 'Actions',
  'pages.inquiryBatch.col.rowIndex': 'Excel row',
  'pages.inquiryBatch.col.projectName': 'Project name',
  'pages.inquiryBatch.col.inquiryId': 'Inquiry ID',
  'pages.inquiryBatch.col.errorMsg': 'Failure reason',
  'pages.inquiryBatch.status.PENDING': 'Pending',
  'pages.inquiryBatch.status.RUNNING': 'Running',
  'pages.inquiryBatch.status.SUCCESS': 'All succeeded',
  'pages.inquiryBatch.status.PARTIAL': 'Partial success',
  'pages.inquiryBatch.status.FAILED': 'All failed',
  'pages.inquiryBatch.status.CANCELLED': 'Cancelled',
  'pages.inquiryBatch.search.inquiryTime': 'Inquiry time',
  'pages.inquiryBatch.search.status': 'Inquiry status',
  'pages.inquiryBatch.ph.status': 'Select status',
};
